// @ts-nocheck
import React, { useState, ChangeEvent, FormEvent } from 'react'
import { useApi } from '../../../hooks/useApi'
import { convertGweiToWei } from '../../../utils/web3-utils'
import CustomInput from '../../general/Form'
import MiniSwitch from '../../formUtils/MiniSwitch'
import styled from 'styled-components'

interface Web3FormProps {
  onSuccess?: () => void
}

interface FormValues {
  chainId: string
  denied: boolean
  name: string
  symbol: string
  subgraphUrl: string
  subgraphId: string
  thresholdAmount: number
  gasThresholdAmount: number
  executorGasLimitBufferPct: number
  transactionDelaySeconds: number
  transactionsExpirationSeconds: number
  missingTxMinutesTimeout: number
  minimumMinutesBetweenExecutions: number
  maxPriorityFeePerGas: string
  inactiveMinutesToNotify: number
  executorBalanceThresholdUsd: number
  explorerUrl: string
}

const Web3Form: React.FC<Web3FormProps> = ({ onSuccess = () => {} }) => {
  const { callApi } = useApi()
  const [formValues, setFormValues] = useState<FormValues>({
    chainId: '',
    denied: false,
    name: '',
    symbol: '',
    subgraphUrl: '',
    subgraphId: '',
    maxPriorityFeePerGas: '',
    thresholdAmount: 0,
    gasThresholdAmount: 0,
    executorGasLimitBufferPct: 0,
    transactionDelaySeconds: 0,
    transactionsExpirationSeconds: 0,
    missingTxMinutesTimeout: 0,
    minimumMinutesBetweenExecutions: 0,
    inactiveMinutesToNotify: 0,
    executorBalanceThresholdUsd: 0,
    explorerUrl: '',
  })
  const [message, setMessage] = useState<string>('')

  const handleFormSubmit = async (e: FormEvent) => {
    e.preventDefault()
    try {
      const params = {
        chainId: parseInt(formValues.chainId, 10),
        denied: formValues.denied,
        name: formValues.name,
        symbol: formValues.symbol,
        subgraphUrl: formValues.subgraphUrl,
        subgraphId: formValues.subgraphId,
        maxPriorityFeePerGas: formValues.maxPriorityFeePerGas,
        thresholdAmount: parseInt(String(formValues.thresholdAmount), 10),
        gasThresholdAmount: convertGweiToWei(parseInt(String(formValues.gasThresholdAmount), 10)),
        executorGasLimitBufferPct: parseInt(String(formValues.executorGasLimitBufferPct), 10),
        transactionDelaySeconds: parseInt(String(formValues.transactionDelaySeconds), 10),
        transactionsExpirationSeconds: parseInt(String(formValues.transactionsExpirationSeconds), 10),
        missingTxMinutesTimeout: parseInt(String(formValues.missingTxMinutesTimeout), 10),
        minimumMinutesBetweenExecutions: parseInt(String(formValues.minimumMinutesBetweenExecutions), 10),
        inactiveMinutesToNotify: parseInt(String(formValues.inactiveMinutesToNotify), 10),
        executorBalanceThresholdUsd: parseInt(String(formValues.executorBalanceThresholdUsd), 10),
        explorerUrl: formValues.explorerUrl,
      }
      await callApi('/relayer-executor/chains', params, 'POST')
      onSuccess()
    } catch (error) {
      console.error('Error in handleFormSubmit:', error)
    }
  }

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }))
  }

  return (
    <Form onSubmit={handleFormSubmit}>
      {message !== '' ? (
        <FeedbackBanner>
          <span>{message}</span>
          <CloseBtn onClick={() => setMessage('')}>✕</CloseBtn>
        </FeedbackBanner>
      ) : (
        <>
          <FieldGrid>
            <CustomInput type="number" label="Chain Id" name="chainId" modal value={formValues.chainId} onChange={handleInputChange} required />
            <CustomInput type="text" label="Symbol" name="symbol" modal value={formValues.symbol} onChange={handleInputChange} required />
            <CustomInput type="text" label="Name" name="name" modal value={formValues.name} onChange={handleInputChange} required />
            <CustomInput type="number" label="Threshold Amount" name="thresholdAmount" modal value={formValues.thresholdAmount || 0} onChange={handleInputChange} required />
            <CustomInput type="number" label="Gas Threshold Amount (Gwei)" name="gasThresholdAmount" modal value={formValues.gasThresholdAmount || 0} onChange={handleInputChange} required />
            <CustomInput type="number" label="Gas Limit Buffer Pct" name="executorGasLimitBufferPct" modal value={formValues.executorGasLimitBufferPct || 0} onChange={handleInputChange} required />
            <CustomInput type="number" label="Tx Delay Seconds" name="transactionDelaySeconds" modal value={formValues.transactionDelaySeconds || 0} onChange={handleInputChange} required />
            <CustomInput type="number" label="Tx Expiration Seconds" name="transactionsExpirationSeconds" modal value={formValues.transactionsExpirationSeconds || 0} onChange={handleInputChange} required />
            <CustomInput type="number" label="Tx Missing Timeout" name="missingTxMinutesTimeout" modal value={formValues.missingTxMinutesTimeout || 0} onChange={handleInputChange} required />
            <CustomInput type="text" label="Subgraph Url" name="subgraphUrl" modal value={formValues.subgraphUrl || ''} onChange={handleInputChange} required />
            <CustomInput type="text" label="Subgraph Id" name="subgraphId" modal value={formValues.subgraphId || ''} onChange={handleInputChange} required />
            <CustomInput type="number" label="Minimum Minutes Between Executions" name="minimumMinutesBetweenExecutions" modal value={formValues.minimumMinutesBetweenExecutions || 0} onChange={handleInputChange} required />
            <CustomInput type="text" label="Max Priority Fee Per Gas" name="maxPriorityFeePerGas" modal value={formValues.maxPriorityFeePerGas || ''} onChange={handleInputChange} />
            <CustomInput type="number" label="Inactive Minutes To Notify" name="inactiveMinutesToNotify" modal value={formValues.inactiveMinutesToNotify || 0} onChange={handleInputChange} required />
            <CustomInput type="number" label="Executor Balance Threshold (USD)" name="executorBalanceThresholdUsd" modal value={formValues.executorBalanceThresholdUsd || 0} onChange={handleInputChange} required />
            <CustomInput type="text" label="Explorer URL" name="explorerUrl" modal value={formValues.explorerUrl || ''} onChange={handleInputChange} required />
            <SwitchField>
              <SwitchLabel>Denied</SwitchLabel>
              <MiniSwitch ison={formValues.denied} onToggle={() => setFormValues(v => ({ ...v, denied: !v.denied }))} />
            </SwitchField>
          </FieldGrid>
          <SubmitBtn type="submit">Add network</SubmitBtn>
        </>
      )}
    </Form>
  )
}

export default Web3Form

// ─── Styles ──────────────────────────────────────────────────────────────────

const Form = styled.form`display: flex; flex-direction: column; gap: 16px;`
const FieldGrid = styled.div`display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 8px; align-items: start;`
const SwitchField = styled.div`display: flex; flex-direction: column; gap: 8px;`
const SwitchLabel = styled.label`font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: #777;`
const SubmitBtn = styled.button`height: 34px; padding: 0 16px; align-self: flex-start; background: rgba(111,92,230,0.15); border: 1px solid rgba(111,92,230,0.35); border-radius: 6px; color: #a89aff; font-size: 13px; font-weight: 500; cursor: pointer; transition: background 0.15s, border-color 0.15s; &:hover { background: rgba(111,92,230,0.25); border-color: rgba(111,92,230,0.5); }`
const FeedbackBanner = styled.div`display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; background: rgba(51,194,176,0.08); border: 1px solid rgba(51,194,176,0.25); border-radius: 6px; color: #33C2B0; font-size: 13px;`
const CloseBtn = styled.button`background: transparent; border: none; color: inherit; cursor: pointer; font-size: 12px; opacity: 0.7; &:hover { opacity: 1; }`
